import type { TelemetryOptions } from '@ms-cloudpack/telemetry';
import type { CommandEvents } from '../utilities/commandEvents.js';

/**
 * These options are not provided on the command line but need to be shared between commands.
 */
export interface ProgramOptions {
  /**
   * Initial working directory (usually `process.cwd()` except in tests).
   * Note that this may differ from the `appPath` used by individual commands.
   */
  cwd: string;

  /** Raw argv (usually `process.argv` except in tests). */
  argv: string[];

  /** CLI version. */
  version: string;

  /**
   * Shared event emitter for lifecycle events across an entire command run.
   * This is currently only used for tests, and it will only exist if the test creates it.
   * (It must be passed around instead of being a global singleton to ensure test isolation.)
   */
  commandEvents: CommandEvents;

  /**
   * Telemetry options for testing. By default in tests, no telemetry will be sent even if a connection
   * string is present in the effective config, but the telemetry infrastructure is still initialized
   * and events are logged internally (and to the console if the `verbose` or `debug` CLI flag is set).
   */
  telemetryOptions: Partial<TelemetryOptions> | undefined;
}
